import { CalendarDateTime } from '@internationalized/date';
import { View } from '@shared/components/View';
import ClockAnimatedIcon from './time-clock-animated.svg';
import styles from './TimeClock.module.css';

export interface CurrentTimeClockProps {
  time: CalendarDateTime | null;
  className?: string;
}

export function TimeClock({ time, className }: CurrentTimeClockProps) {
  const hour = time?.hour ?? 0;
  const minute = time?.minute ?? 0;

  const hourAngle = (hour % 12) * 30;
  const minuteAngle = minute * 6;
  return (
    <View vars={{ hourAngle, minuteAngle }} className={[styles.timeClock]}>
      <ClockAnimatedIcon className={className} />
    </View>
  );
}
